import React from "react";

import CodePill from './CodePill'
import {Link} from 'react-router-dom'
import { useCodePageModal } from './contexts/CodePageModalContext';


function CodePillLink(props) {

  const { openModal } = useCodePageModal();
  
  function onCodeClick(e)
  {
    if ( e ) {
      e.preventDefault(); // Prevent the default link action
      e.stopPropagation(); // Prevent the event from bubbling up
    }
     
    const {id, onClick} = props;
    if ( !!onClick ) onClick();
    
    if ( id ) openModal(id);
  }

  if ( props.codePage )
  {
    const to = props.id ? `/projects/${props.projectID}/codes/${props.id}` :
                                  `/projects/${props.projectID}/codes/`;

    return(
      <Link to={to} style={{cursor:'pointer', paddingRight:0, color: 'inherit', textDecoration: 'none'}}>
        <span style={{paddingRight:0}}>
            <CodePill
              name={props.name}
              codeColor={props.codeColor}
              selected={props.selected}
            />
        </span>
      </Link>
    );
  }
  else {
    return(
      <span onClick={onCodeClick} style={{cursor:'pointer', paddingRight:0, maxWidth: "100%"}}>
        <CodePill
          name={props.name}
          codeColor={props.codeColor}
          selected={props.selected}
        />
      </span>
    );
  }
}

export default CodePillLink;
